var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({directives:[{name:"stack-y",rawName:"v-stack-y:2xs",arg:"2xs"}],ref:"root",tag:"component",class:{
    'slo-field': true,
    'focus-within': _vm.focusWithin,
    disabled: _vm.disabled
  }},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }